<template>
  <component
    :is="isBlocked ? 'div' : 'router-link'"
    class="home-module-card text-decoration-none"
    :to="{ name: 'module', params }"
  >
    <div
      class="module-card-wrapper"
      :class="{ blocked: isBlocked }"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <div class="module-card" :style="style">
        <div v-if="isBlocked" class="blocked-wrapper">
          <span>Módulo bloqueado</span>
          <i class="icon-lock" />
          <span>
            Este módulo será liberado
            {{ timeToRelease }}
          </span>
        </div>
        <i v-if="noCoverAndNoPlaceholder" class="icon-blitzpay-placeholder" />
      </div>
    </div>
    <div class="module-description">
      <h5 class="module-name pt-2">{{ module.name }}</h5>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hover: false,
      params: {
        id: this.module.id
      }
    };
  },
  computed: {
    noCoverAndNoPlaceholder() {
      return !this.module.picture && !this.$setup.setup.placeholder_module;
    },
    style() {
      const url =
        this.module.picture || this.$setup.setup.placeholder_module || "";
      const gradient = "linear-gradient(0deg, #0b0b1295 0%, #0b0b1200 80%)";

      if (this.hover && !this.isBlocked) {
        return `
          background-image: url(${url});
        `;
      }

      if (url && url.length) {
        return `
            background-image: ${gradient}, url(${url});
          `;
      }

      return "";
    },
    isBlocked() {
      return this.module?.is_blocked.status;
    },
    timeToRelease() {
      let days_left_for_release =
        this.module?.is_blocked.days_left_to_release ||
        this.module?.is_blocked.days_left_for_release;

      if (!days_left_for_release) return "em breve";

      return days_left_for_release == 1
        ? "amanhã"
        : `em ${days_left_for_release} dias`;
    }
  }
};
</script>

<style lang="scss" scoped>
.home-module-card {
  .module-card-wrapper {
    padding: 0;
    border-radius: 6px;
    transition: border 0.1s ease-in-out, padding 0.1s ease-in-out;

    @media screen and (max-width: 400px) {
      width: 200px;
    }

    .icon-lock {
      font-size: 30px;
    }

    .module-card {
      aspect-ratio: 200/290;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      height: 100%;
      width: 100%;
      border-radius: 6px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .icon-blitzpay-placeholder {
        font-size: 48px;
      }
    }

    .blocked-wrapper {
      background: rgba(50, 28, 61, 0.8);
      border-radius: 6px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      gap: 16px;
      font-weight: 500;
      color: #bebfc7;
      padding: 0px 12px;
      display: flex;
      text-align: center;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      i {
        color: #ffffffcc;
        font-size: 32px;
        @media screen and (max-width: 768px) {
          font-size: 28px;
        }
        @media screen and (max-width: 540px) {
          font-size: 20px;
        }
      }
    }

    &:not(.blocked):hover {
      border: 2px solid #6b3ead !important;
      padding: 2.5px;
      .module-card {
        border-radius: 4px;
      }
    }
  }
  .module-description {
    display: grid;
    .module-name {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      overflow: hidden;
      text-overflow: ellipsis;

      @media screen and (max-width: 768px) {
        font-size: 12px !important;
      }
    }
  }
}
</style>
